import React from 'react';
import { Tooltip } from '@mui/material';
import { ConnectionStatus } from '../../types';
import { getStatusLabel } from '../../utils/connectionUtils';
import { useForceUpdateInterval } from '../../hooks/useForceUpdateInterval';
import TooltipContent from './TooltipContent';
import StatusChip from './StatusChip';
import useAlias from '@alias';

interface ConnectionIndicatorProps {
  connectionStatus: ConnectionStatus;
  lastDataUpdate?: Date | null;
}

const ConnectionIndicator: React.FC<ConnectionIndicatorProps> = ({
  connectionStatus,
  lastDataUpdate,
}) => {
  const alias = useAlias();
  useForceUpdateInterval(lastDataUpdate);

  const displayStatus = connectionStatus;
  const statusLabel = getStatusLabel(displayStatus, 0, alias);

  const tooltipContent = (
    <TooltipContent
      statusLabel={statusLabel}
      lastDataUpdate={lastDataUpdate}
      displayStatus={displayStatus}
    />
  );

  return (
    <Tooltip title={tooltipContent} placement='top' arrow>
      <span>
        <StatusChip statusLabel={statusLabel} displayStatus={displayStatus} />
      </span>
    </Tooltip>
  );
};

ConnectionIndicator.displayName = 'ConnectionIndicator';

export default ConnectionIndicator;
